// Campos enmascarados por api2 en GET /booking/paxs/{cid}: email, teléfono,
// documento y dirección llegan como "****" + últimos 4 caracteres. El front no
// los edita en el lugar: los muestra como pista (placeholder), deja el input
// vacío y sólo envía lo que el huésped cambió. Nunca se envía un valor "****".
export const MASK_PREFIX = "****";

// Campos de sólo lectura que el listado trae y que no se envían en el PUT.
const READ_ONLY_FIELDS = [
  "has_document_front",
  "has_document_back",
  "has_signature"
];

export const isMaskedValue = value =>
  typeof value === "string" && value.indexOf(MASK_PREFIX) === 0;

// Copia del pax con los valores enmascarados reemplazados por "".
export const stripMaskedValues = pax => {
  if (!pax || typeof pax !== "object") return pax;
  const clean = { ...pax };
  Object.keys(clean).forEach(key => {
    if (isMaskedValue(clean[key])) clean[key] = "";
  });
  return clean;
};

// { campo: "****1234" } de un pax del listado.
export const collectMaskedHints = pax => {
  const hints = {};
  if (!pax || typeof pax !== "object") return hints;
  Object.keys(pax).forEach(key => {
    if (isMaskedValue(pax[key])) hints[key] = pax[key];
  });
  return hints;
};

// Cuerpo del PUT de un pax: sin valores "****" y, para los campos que el
// servidor tiene enmascarados, sólo si el huésped escribió un valor nuevo.
export const buildPaxPayload = (pax, hints) => {
  const payload = {};
  const masked = hints || {};
  Object.keys(pax || {}).forEach(key => {
    const value = pax[key];
    if (READ_ONLY_FIELDS.indexOf(key) !== -1) return;
    if (isMaskedValue(value)) return;
    if (
      Object.prototype.hasOwnProperty.call(masked, key) &&
      (value === "" || value === null || typeof value === "undefined")
    )
      return;
    payload[key] = value;
  });
  return payload;
};

// ¿El pax tiene documento cargado? Con la API nueva el listado no trae URLs
// sino has_document_front / has_document_back; el formato viejo trae `documents`.
export const hasDocuments = pax =>
  Boolean(
    pax &&
      ((pax.documents && pax.documents.length) ||
        pax.has_document_front ||
        pax.has_document_back)
  );
